import React from 'react'
import PropTypes from 'prop-types'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import OverviewHero from './OverviewHero'
import SectionNavCards from './SectionNavCards'

export default function Overview({
  summary = {},
  scoring = { overall: {}, sections: [] },
  recommendations = [],
  findings = [],
}) {
  const current = scoring.overall.current ?? {}
  const afterRecommendations = scoring.overall.afterRecommendations ?? {}
  const afterRecommendationsAndLicenses = scoring.overall.afterRecommendationsAndLicenses ?? {}

  return (
    <>
      <SectionHeading titleId="AI_RISK_REPORT.OVERVIEW.TITLE" />
      <OverviewHero
        overall={current.value}
        overallTone={current.tone}
        projected={afterRecommendations.value}
        projectedTone={afterRecommendations.tone}
        projectedWithLicenses={afterRecommendationsAndLicenses.value}
        showLicensedProjection={recommendations.some(({ type }) => type === 'license')}
        summary={summary}
        recommendationCount={recommendations.length}
        findings={findings}
      />
      <SectionNavCards scoring={scoring} />
    </>
  )
}

Overview.propTypes = {
  summary: PropTypes.shape({}),
  scoring: PropTypes.shape({
    overall: PropTypes.shape({
      current: PropTypes.shape({ value: PropTypes.number, tone: PropTypes.string }),
      afterRecommendations: PropTypes.shape({
        value: PropTypes.number,
        tone: PropTypes.string,
      }),
      afterRecommendationsAndLicenses: PropTypes.shape({
        value: PropTypes.number,
        tone: PropTypes.string,
      }),
    }),
    sections: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  recommendations: PropTypes.arrayOf(PropTypes.shape({})),
  findings: PropTypes.arrayOf(PropTypes.shape({})),
}
